import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

/*const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};*/
const firebaseConfig = {
    apiKey: "AIzaSyCYx0c715IFghu_Chv2V8sT5erFeVjWfps",
    authDomain: "tickets-manager-3d614.firebaseapp.com",
    projectId: "tickets-manager-3d614",
    storageBucket: "tickets-manager-3d614.firebasestorage.app",
    messagingSenderId: "2838436265",
    appId: "1:2838436265:web:4beee0c1b7997ddb144cb8",
    measurementId: "G-N6WMKK5Y4J"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;